export default {
    state: {
      groups: [],
      sent: false
    },
    mutations: {
        sendGroups(state, payload) {
            state.groups.push(payload)
        },
        isSent(state, payload) {
            state.sent = payload
        }
    },
    actions: {
        sendGroups(state, payload) {
            state.commit('sendGroups', payload)
        },
        isSent(state, payload) {
            state.commit('isSent', payload)
        }
    },
    getters: {
        getSentGroups(state) {
            return state.groups
        },
        getIsSent(state) {
            return state.sent
        },
    }
}


  